import { render } from "./PDFDocument.vue?vue&type=template&id=4ebb5c18"
import script from "./PDFDocument.vue?vue&type=script&lang=js"
export * from "./PDFDocument.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__